import { Icon } from '@foam/buoy/src/components/Icon/Icon';
import { cn } from '@foam/buoy/src/lib/utils';

interface ContentCheckboxProps {
  isChecked: boolean;
  isShared: boolean;
  onCheckboxChange?: (checked: boolean) => void;
}

export const ContentCheckbox = ({
  isChecked,
  isShared,
  onCheckboxChange,
}: ContentCheckboxProps) => {
  if (isShared) {
    return null;
  }

  return (
    <div
      className={cn(
        'absolute right-2 top-2 transition-opacity duration-200 z-10',
        {
          'opacity-100': isChecked,
          'opacity-0 group-hover:opacity-100': !isChecked,
        },
      )}
    >
      <div
        className={cn(
          'flex size-8 cursor-pointer items-center justify-center rounded-100 transition-colors duration-200',
          {
            'border-orange-500 bg-orange-500': isChecked,
          },
        )}
        onClick={(e) => {
          e.stopPropagation();
          onCheckboxChange?.(!isChecked);
        }}
      >
        {isChecked && <Icon name="Checkmark" color="white" />}
      </div>
    </div>
  );
};
